"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentSchema = exports.AllRoles = exports.Role = void 0;
const yup_1 = require("yup");
const model_schema_1 = require("../base/model.schema");
var Role;
(function (Role) {
    Role["ADMIN"] = "ADMIN";
    Role["AGENT"] = "AGENT";
    Role["SUPERVISOR"] = "SUPERVISOR";
    Role["REPORTING"] = "REPORTING";
    Role["QA"] = "QA";
    Role["QA_ADMIN"] = "QA_ADMIN";
    Role["USER"] = "USER";
    Role["USER_EDIT"] = "USER_EDIT";
    Role["CALL_DOWNLOAD"] = "CALL_DOWNLOAD";
    Role["LIVE_MONITORING"] = "LIVE_MONITORING";
    Role["LINE_MANAGEMENT"] = "LINE_MANAGEMENT";
})(Role = exports.Role || (exports.Role = {}));
exports.AllRoles = Object.keys(Role).map(r => Role[r]); //[Role.ADMIN, Role.AGENT, Role.SUPERVISOR, Role.REPORTING, Role.QA, Role.USER, Role.QA_ADMIN, Role.LIVE_MONITORING];
exports.AgentSchema = model_schema_1.Schema.shape({
    companyID: (0, yup_1.string)().required(),
    instanceID: (0, yup_1.string)().required(),
    email: (0, yup_1.string)()
        .email()
        .notRequired(),
    firstName: (0, yup_1.string)().required(),
    lastName: (0, yup_1.string)().required(),
    username: (0, yup_1.string)().required(),
    mobileNumber: (0, yup_1.string)().notRequired(),
    afterWorkTimeLimit: (0, yup_1.number)().notRequired(),
    autoAccept: (0, yup_1.boolean)().notRequired(),
    phoneType: (0, yup_1.mixed)()
        .oneOf(['SOFT_PHONE', 'DESK_PHONE'])
        .required(),
    lastLogin: (0, yup_1.number)().notRequired(),
    routingProfileID: (0, yup_1.string)().required(),
    securityRoles: (0, yup_1.array)((0, yup_1.string)()),
    securityGroupIDs: (0, yup_1.array)((0, yup_1.string)()).required(),
    hierarchyGroupID: (0, yup_1.string)().notRequired(),
    hierarchyStructure: (0, yup_1.string)().notRequired(),
    deskPhoneNumber: (0, yup_1.string)().notRequired(),
    mfa: (0, yup_1.mixed)()
        .oneOf(['PHONE', 'EMAIL', 'OFF', 'TOTP'])
        .notRequired(),
    externalID: (0, yup_1.string)().notRequired(),
    disabled: (0, yup_1.boolean)().default(false),
    timeZone: (0, yup_1.string)().notRequired(),
    tags: (0, yup_1.object)().notRequired()
});
